import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const news = {
  fetchNewsBulletinItems: lazyModuleMethod(
    () => import('./fetchNewsBulletinItems'),
    'default'
  ),
}
